import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux';
import { fetchClinicianAvailability } from '../../redux/scraper/scraperSlice';
import { sendClinicianInvite  } from '../../redux/scraper/scraperSlice';


export const useClinicianAvailability = () => {
    const dispatch = useDispatch<AppDispatch>();
    const availability = useSelector((state: RootState) => state.scraper.clinicianAvailability);
    
    const fetch = useCallback((params?: { date?: string; clinician?: string; practiceId?: string; limit?: number }) => 
      dispatch(fetchClinicianAvailability(params)), [dispatch]);
    
    const sendInvite = useCallback((params: { clinicianId: string; email: string; name: string }) =>
      dispatch(sendClinicianInvite(params)), [dispatch]);
    
    return { ...availability, fetch, sendInvite };
};